// extracted by mini-css-extract-plugin
export default {"fatsecret":"FatsecretImage_fatsecret__Z4k0a"};